var _g, _g2, _g3, _g4, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 183,
    viewBox: "0 0 183 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_b_2322_50859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.25 156.618H129.625V154.711C129.625 146.324 122.762 139.461 114.375 139.461H97.2188V122C95.3125 122.229 93.4062 122.305 91.5 122.305C89.5938 122.305 87.6875 122.229 85.7812 122V139.461H68.625C60.2375 139.461 53.375 146.324 53.375 154.711V156.618H45.75C42.6237 156.618 40.0312 159.21 40.0312 162.336C40.0312 165.463 42.6237 168.055 45.75 168.055H137.25C140.376 168.055 142.969 165.463 142.969 162.336C142.969 159.21 140.376 156.618 137.25 156.618Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_b_2322_50859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0907 88.755C37.0582 86.8488 32.6357 83.7225 29.1282 80.215C22.037 72.3613 17.3857 62.9825 17.3857 52.0025C17.3857 41.0225 26.002 32.4062 36.982 32.4062H41.252C39.2695 36.4475 38.1257 40.9463 38.1257 45.75V68.625C38.1257 75.7925 39.4982 82.5788 42.0907 88.755Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_b_2322_50859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.614 52.0025C165.614 62.9825 160.963 72.3613 153.872 80.215C150.364 83.7225 145.942 86.8488 140.909 88.755C143.502 82.5788 144.874 75.7925 144.874 68.625V45.75C144.874 40.9463 143.73 36.4475 141.748 32.4062H146.018C156.998 32.4062 165.614 41.0225 165.614 52.0025Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_b_2322_50859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.377 15.25H68.627C51.7757 15.25 38.127 28.8988 38.127 45.75V68.625C38.127 98.1338 61.9932 122 91.502 122C121.011 122 144.877 98.1338 144.877 68.625V45.75C144.877 28.8988 131.228 15.25 114.377 15.25ZM113.157 64.4313L108.429 70.2263C107.667 71.065 107.133 72.7425 107.209 73.8863L107.667 81.3588C107.972 85.9338 104.693 88.2975 100.423 86.62L93.4845 83.875C92.417 83.4938 90.587 83.4938 89.5195 83.875L82.5807 86.62C78.3107 88.2975 75.032 85.9338 75.337 81.3588L75.7945 73.8863C75.8707 72.7425 75.337 71.065 74.5745 70.2263L69.847 64.4313C66.8732 60.9238 68.1695 57.035 72.592 55.8913L79.8357 54.0613C80.9795 53.7563 82.352 52.6888 82.962 51.6975L87.0032 45.445C89.5195 41.5563 93.4845 41.5563 96.0007 45.445L100.042 51.6975C100.652 52.6888 102.024 53.7563 103.168 54.0613L110.412 55.8913C114.834 57.035 116.131 60.9238 113.157 64.4313Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M113.156 64.4304L108.428 70.2254C107.666 71.0641 107.132 72.7416 107.208 73.8854L107.666 81.3579C107.971 85.9329 104.692 88.2966 100.422 86.6191L93.483 83.8742C92.4155 83.4929 90.5855 83.4929 89.518 83.8742L82.5793 86.6191C78.3093 88.2966 75.0305 85.9329 75.3355 81.3579L75.793 73.8854C75.8693 72.7416 75.3355 71.0641 74.573 70.2254L69.8455 64.4304C66.8718 60.9229 68.168 57.0341 72.5905 55.8904L79.8343 54.0604C80.978 53.7554 82.3505 52.6879 82.9605 51.6967L87.0018 45.4442C89.518 41.5554 93.483 41.5554 95.9993 45.4442L100.041 51.6967C100.651 52.6879 102.023 53.7554 103.167 54.0604L110.411 55.8904C114.833 57.0341 116.129 60.9229 113.156 64.4304Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2322_50859",
    x: -108.139,
    y: -26.1699,
    width: 399.277,
    height: 342.395,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 74.0849
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2322_50859"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2322_50859",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2322_50859",
    x: -130.784,
    y: -115.764,
    width: 321.045,
    height: 352.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 74.0849
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2322_50859"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2322_50859",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_2322_50859",
    x: -7.26068,
    y: -115.764,
    width: 321.045,
    height: 352.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 74.0849
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2322_50859"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2322_50859",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_2322_50859",
    x: -110.043,
    y: -132.92,
    width: 403.09,
    height: 403.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 74.0849
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2322_50859"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2322_50859",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.6df80cd86a84da218ed53ca6661eb584.svg";
export { ForwardRef as ReactComponent };